import Search16 from '@carbon/icons-react/es/search/16';
import { Typography } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { components as ReactSelectComponents, ValueType } from 'react-select';
import styled from 'styled-components';
import { Avatar, AvatarGroup } from 'components/atoms/avatar';
import { Button } from 'components/atoms/button';
import { HeightStyle } from 'components/atoms/input/input';
import { AvatarTag } from '../custom-components';
import { SelectMode, Option } from '../types';

export const DropdownIndicator = (props) => {
  return (
    <ReactSelectComponents.DropdownIndicator {...props}>
      <Search16 />
    </ReactSelectComponents.DropdownIndicator>
  );
};

export const Menu = styled(ReactSelectComponents.Menu)`
  box-shadow: none;
`;

const Trigger = styled(Typography.Link)<{ size?: SizeType }>`
  display: flex;
  align-items: center;
  min-height: ${HeightStyle};
  &:focus,
  &:hover {
    background-color: var(--hover-color);
  }
`;

const TriggerPlaceholder = ({ isDisabled, onClick, size }: TriggerProps) => (
  <Trigger
    size={size}
    disabled={isDisabled}
    onClick={() => {
      onClick();
    }}
  >
    <FormattedMessage id="choose" />
  </Trigger>
);

const renderValue = (props: TriggerProps): JSX.Element => {
  const { value: valueFromProp, type = 'user', onClick, isDisabled } = props;
  const value = valueFromProp as Option;

  switch (type) {
    case 'basic': {
      return (
        <Button
          type="text"
          size="small"
          onClick={onClick}
          disabled={isDisabled}
        >
          {value?.label}
        </Button>
      );
    }
    case 'user':
    case 'tag':
    default: {
      return (
        <AvatarTag
          label={value.label}
          imageUrl={value.imageUrl}
          logoUrl={value.logoUrl}
          {...props}
        />
      );
    }
  }
};

const SingleValueTrigger = (props: TriggerProps) => {
  const { value: value1 } = props;
  const value = value1 as Option;

  return value ? renderValue(props) : <></>;
};

const MultiValueTrigger = (props: TriggerProps) => {
  const { value: value1, onClick, isDisabled, size, className } = props;
  const value = value1 as Option[];

  return value ? (
    <Button
      className={className}
      type="text"
      size={size}
      onClick={onClick}
      disabled={isDisabled}
    >
      <AvatarGroup maxCount={2}>
        {value.map((opt) => (
          <Avatar
            key={opt.value}
            name={opt.label}
            src={opt.imageUrl}
            companyLogoUrl={opt.logoUrl}
            size="small"
          />
        ))}
      </AvatarGroup>
    </Button>
  ) : (
    <></>
  );
};

export const triggerComponents = {
  TriggerPlaceholder,
  SingleValueTrigger,
  MultiValueTrigger,
};

export type Value = ValueType<Option, boolean>;

export interface TriggerProps {
  shouldRenderValue?: boolean;
  isDisabled?: boolean;
  isMulti: boolean;
  placeholder?: string;
  value: Value;
  onClick: () => void;
  components: typeof triggerComponents;
  size?: SizeType;
  className?: string;
  type?: SelectMode;
}
